{
  "INBOX": {
    "LIST": {
      "404": "There are no active notifications in this group.",
      "TITLE": "My Inbox",
      "DISPLAY_DROPDOWN": "Display",
      "LOADING": "Fetching notifications",
      "NO_NOTIFICATIONS": "No notifications",
      "NOTE": "Notifications from all subscribed inboxes",
      "NO_MESSAGES_AVAILABLE": "Oops! Not able to fetch messages",
      "SNOOZED_UNTIL": "Amânare până la",
      "SNOOZED_UNTIL_TOMORROW": "Amânat până mâine",
      "SNOOZED_UNTIL_NEXT_WEEK": "Amânat până săptămâna viitoare"
    },
    "ACTION_HEADER": {
      "SNOOZE": "Snooze notification",
      "DELETE": "Delete notification",
      "BACK": "Înapoi"
    },
    "TYPES": {
      "CONVERSATION_MENTION": "You have been mentioned in a conversation",
      "CONVERSATION_CREATION": "New conversation created",
      "CONVERSATION_ASSIGNMENT": "A conversation has been assigned to you",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "New message in an assigned conversation",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "New message in a conversation you are participating in",
      "SLA_MISSED_FIRST_RESPONSE": "SLA target first response missed for conversation",
      "SLA_MISSED_NEXT_RESPONSE": "SLA target next response missed for conversation",
      "SLA_MISSED_RESOLUTION": "SLA target resolution missed for conversation"
    },
    "TYPES_NEXT": {
      "CONVERSATION_MENTION": "Mentioned",
      "CONVERSATION_ASSIGNMENT": "Assigned to you",
      "CONVERSATION_CREATION": "New Conversation",
      "SLA_MISSED_FIRST_RESPONSE": "SLA breach",
      "SLA_MISSED_NEXT_RESPONSE": "SLA breach",
      "SLA_MISSED_RESOLUTION": "SLA breach",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Mesaj nou",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Mesaj nou",
      "SNOOZED_UNTIL": "Snoozed for {time}",
      "SNOOZED_ENDS": "Snooze ended",
      "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Mesaj nou"
    },
    "NO_CONTENT": "Nici un conținut disponibil",
    "PHONE_CALL_TYPES": {
      "OUTBOUND_CONNECTED": "Apel efectuat - Conectat",
      "OUTBOUND_FAILED": "Apel efectuat - Eșuat",
      "INBOUND_MISSED": "Apel primit - Ratat",
      "INBOUND_UNANSWERED_MISSED": "Apel primit - Ratat fără răspuns",
      "INBOUND_AGENT": "Apel primit - Preluat de agent",
      "INBOUND_IVR": "Apel primit - Preluat de IVR",
      "DEFAULT": "Apel telefonic"
    },
    "MENU_ITEM": {
      "MARK_AS_READ": "Mark as read",
      "MARK_AS_UNREAD": "Marcheaza ca necitit",
      "SNOOZE": "Amânați",
      "DELETE": "Şterge",
      "MARK_ALL_READ": "Marcare totală ca citit",
      "DELETE_ALL": "Delete all",
      "DELETE_ALL_READ": "Delete all read"
    },
    "DISPLAY_MENU": {
      "SORT": "Sort",
      "DISPLAY": "Display :",
      "SORT_OPTIONS": {
        "NEWEST": "Newest",
        "OLDEST": "Oldest",
        "PRIORITY": "Prioritate"
      },
      "DISPLAY_OPTIONS": {
        "SNOOZED": "Amânat",
        "READ": "Citește",
        "LABELS": "Etichete",
        "CONVERSATION_ID": "Conversation ID"
      }
    },
    "ALERTS": {
      "MARK_AS_READ": "Notification marked as read",
      "MARK_AS_UNREAD": "Notification marked as unread",
      "SNOOZE": "Notification snoozed",
      "DELETE": "Notification deleted",
      "MARK_ALL_READ": "All notifications marked as read",
      "DELETE_ALL": "All notifications deleted",
      "DELETE_ALL_READ": "All read notifications deleted"
    }
  }
}
